<div class="js-select-container form-inline">
	<div class="display-block-on-small-screen xxs-m-b-10">
		<select id="js-start-hour" class="js-dropdown-time form-control form-control-inline">
		{{#each hours}}
			<option value={{this.svg}}>{{this.display}}</option>
		{{/each}}
		</select>
		:
		<select id="js-start-minute" class="js-dropdown-time form-control form-control-inline">
		{{#each minutes}}
			<option value={{this.svg}}>{{this.display}}</option>
		{{/each}}
		</select>
		{{TR "bis"}}
	</div>
	<div class="display-block-on-small-screen xxs-m-b-10">
		<select id="js-end-hour" class="js-dropdown-time form-control form-control-inline">
		{{#each hours}}
			<option value={{this.svg}}>{{this.display}}</option>
		{{/each}}
		</select>
		:
		<select id="js-end-minute" class="js-dropdown-time form-control form-control-inline">
		{{#each minutes}}
			<option value={{this.svg}}>{{this.display}}</option>
		{{/each}}
		</select>
	</div>
	<button id="js-delete-interval" class="display-block-on-small-screen-btn btn btn-danger"><i class="fa fa-trash"></i></button>
</div>
